import { Guid } from "../utils/guid.helper";

export class Delivery {
  deliveryId: string;
  name: string;
  tirId: number;
  blastLabel?: string;
  zoneLabel?: string;
  projectId?: number;
  blastHoleCount?: number;
  drillMachine: string;
  startTime: string;
  endTime: string;
  kgDelivered: string;
  detonators: string;
  cartridges: string;
  boosters: string;
  memuId: string;
  holeCount: number;
  blaster: string;
  operators: number[];
  operatorsNames: string;
  isSimpleDelivery: boolean;
}

export class JsonDelivery {
  guid = '';
  startTime: Date;
  endTime: Date;
  departureTime: Date;
  memuId: string | null = '';
  operators: number[] = [];
  operatorID: number | null = null;
  ticketNumber: string | null = '';
  holeDiameter: number | null;
  productId: number | null;
  formulation: string | null = '';
  drillingMachine: string;
  blaster: string | null = '';
  blasterId: number | null = null;
  teamId: number | null = null;
  validationBlaster: boolean;
  validationDriver: boolean;
  client: string | null = '';
  holesDelivery: JsonDeliveryHole[] = [];
  deliveryName: string | null = '';
  kgSend: number | null = null;
  truckId: number | null = null;
  unite: string | null = '';
  bulkId: number | null = null;

  constructor() {
    this.startTime = new Date();
    this.endTime = new Date();
    this.departureTime = new Date();
    this.holeDiameter = null;
    this.productId = null;
    this.validationBlaster = false;
    this.validationDriver = false;
  }
}

export class JsonDeliveryHole {
  guid = '';
  holeId = '';
  drilledDepth: number | null;
  measuredDepth: number | null;
  finalStemmingDepth: number | null;
  kgSend: number | null;
  booster: number | null;
  cartdridge: number | null;
  boosterProductId: number | null;
  holeCondition: string[] = [];
  comment: string | null = '';
  detos: JsonDeliveryDeto[] = [];
  timestamp: Date | null;
  cartdridgeId: number | null = null;
  bulkId: number | null = null;
  holeGuid: string | null = null;


  constructor() {
    this.drilledDepth = null;
    this.measuredDepth = null;
    this.finalStemmingDepth = null;
    this.kgSend = null;
    this.booster = null;
    this.boosterProductId = null;
    this.timestamp = null;
  }
}

export class JsonDeliveryDeto {
  type = '';
  count: number;
  productId: number | null;

  constructor() {
    this.count = 0;
    this.productId = null;
  }
}

export class JsonDeliveryHoleForReport {
  Guid = '';
  DeliveryDate: Date;
  BelongsToPlannedHoles: boolean;
  Hole: JsonDeliveryHole | null;

  constructor() {
    this.DeliveryDate = new Date();
    this.BelongsToPlannedHoles = false;
    this.Hole = null;
  }
}



export class DeliveryForZip {
  deliveryId: string;
  tirId: number;
  constructor(deliveryId: string, tirId: number) {
    this.deliveryId = deliveryId;
    this.tirId = tirId;
  }
}


export class DeliveryRepports {
  deliveryIds: string[];
  resume: boolean;
  constructor(resume: boolean) {
    this.deliveryIds = [];
    this.resume = resume;
  }
}







